import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from './Pages/Portfolio';
import Resume from './Pages/Resume';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<Portfolio />} />
      </Routes>
    </Router>
  );
}

export default App;